// Ziframed Design System - Colores basados en mockups
export const bgApp = '#f3f2f8'
export const bgSurface = '#fcfbff'
export const bgCard = '#f9f8fd'
export const borderSoft = '#e7e0f2'
export const borderMid = '#ddd4ee'
export const textMain = '#2c2150'
export const textSoft = '#84799f'
export const primary = '#7d23ff'
export const primary2 = '#346dff'
export const sidebarBgTop = '#14003a'
export const sidebarBgBottom = '#0f022d'
export const white = '#ffffff'

// Colores adicionales
export const base = 'white'
export const black = '#000'
export const text = '#2c2150'
export const gray = '#f3f2f8'
export const gray10 = '#f9f8fd'
export const gray20 = '#e7e0f2'
export const gray80 = '#84799f'
export const gray90 = '#2c2150'
export const indigo = '#7d23ff'
export const indigoDarken10 = '#6c3bff'
export const indigoLighten80 = '#bbaaf6'
export const yellow = '#e7b520'
export const green = '#4caf50'
export const danger = '#d44744'
export const blue = '#346dff'
export const bluedark = '#2a69ac'
export const orange = 'orange'
export const secondary = '#6c3bff'

// Gradientes
export const sidebarGradient = 'linear-gradient(180deg, #14003a 0%, #0f022d 100%)'
export const buttonGradient = 'linear-gradient(90deg, #8b1eff 0%, #3c68ff 100%)'
export const navActiveGradient = 'linear-gradient(90deg, #8d1dff 0%, #326cff 100%)'